// extracted by mini-css-extract-plugin
export var labelWrapper = "_be-0";